import { DateRange } from '@doss/common-all'
import { CalendarIcon, XIcon } from 'lucide-react'
import { forwardRef } from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { getBaseInputClasses } from '~/@/lib/style-utils'

export interface DateRangePickerInputProps {
  disabled?: boolean
  formatDateDisplay: () => React.ReactNode
  isOpen?: boolean
  onClick: () => void
  value?: DateRange
  isBorderless?: boolean
  readOnly?: boolean
}

export const DateRangePickerInput = forwardRef<HTMLButtonElement, DateRangePickerInputProps>(
  (
    { disabled, formatDateDisplay, isOpen, onClick, value, isBorderless = false, readOnly },
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        className={cn(
          getBaseInputClasses(disabled, isBorderless, readOnly),
          'text-left justify-between active:scale-100',
          !readOnly && 'focus:group-hover/date-picker:border-blue-8',
          !disabled && !isOpen && 'group-hover/date-picker:border-gray-6',
          !value && 'text-gray-8',
        )}
        disabled={disabled}
        onClick={onClick}
        variant="input"
        size="input"
      >
        <span className="flex-1 overflow-hidden text-start text-xs">{formatDateDisplay()}</span>
        <CalendarIcon
          className={cn('h-3.5 w-3.5 flex-shrink-0 text-gray-10', disabled && 'text-gray-9')}
        />
      </Button>
    )
  },
)

DateRangePickerInput.displayName = 'DateRangePickerInput'

export interface DateRangePickerClearButtonProps {
  onChange: (value?: DateRange) => void
}

export function DateRangePickerClearButton({ onChange }: DateRangePickerClearButtonProps) {
  return (
    <div className="absolute end-[34px] top-1/2 flex -translate-y-1/2 cursor-pointer items-center bg-white opacity-0 transition-opacity duration-150 group-focus-within/date-range-picker:opacity-100 group-hover/date-range-picker:opacity-100">
      <XIcon
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onChange(undefined)
        }}
        className="h-3.5 w-3.5 p-0 text-gray-10 transition-colors duration-150"
        aria-label="Clear selection"
      />
    </div>
  )
}
